import React from 'react';
import { useTranslation } from 'react-i18next';

import dogIcon from '../../../assets/dog-active.svg';
import dogInactiveIcon from '../../../assets/dog-inactive.svg';
import catIcon from '../../../assets/cat-active.svg';
import catInactiveIcon from '../../../assets/cat-inactive.svg';

import { FigoInputMessage } from '../FigoInputMessage';
import './ModalAddPet.css';

const SpecieSelectorItem = ({
  handleSpecieSelected = () => { },
  isSelected = false,
  label = '',
  petIcon = null,
  petInactiveIcon = null,
  petSpeciesRef = null,
  describedbyId = '',
}) => {
  const { t } = useTranslation('quoting');
  function specieIcon() {
    if (isSelected) {
      return petIcon;
    }

    return petInactiveIcon;
  }

  return (
    <button
      ref={petSpeciesRef}
      aria-describedby={describedbyId}
      aria-label={isSelected
        ? t('petForm.selectorSelected', {
          type: `${t('petForm.petType')} ${label}`,
        })
        : t('petForm.selectorUnselected', {
          type: `${t('petForm.petType')} ${label}`,
        })}
      aria-live={isSelected ? 'assertive' : 'off'}
      className={'Modal-add-pet-specie-item-container'
        + `${isSelected
          ? ' Modal-add-pet-specie-item-container-selected' : ''}`}
      onClick={handleSpecieSelected}
      type="button"
    >
      <img
        alt=""
        className="Modal-add-pet-specie-icon"
        src={specieIcon()}
      />
      {label}
    </button>
  );
};

const AddPetSpecieSelector = ({
  catSelected = {},
  dogSelected = {},
  dogSpeciesRef = null,
  error = '',
  handleCatSelected = () => { },
  handleDogSelected = () => { },
  noBlankSpace = false,
}) => {
  const { t } = useTranslation('quoting');
  const describedbyId = 'specie-selector-message';
  return (
    <div className="Modal-add-pet-species-wrapper">
      <span className="Modal-add-pet-species-title">
        {t('petForm.petType')}
      </span>

      <div className="Modal-add-pet-container-relative">
        <div className="Modal-add-pet-species-container">
          <SpecieSelectorItem
            describedbyId={describedbyId}
            handleSpecieSelected={handleDogSelected}
            isSelected={dogSelected.selected}
            label={t('petForm.dog')}
            petIcon={dogIcon}
            petInactiveIcon={dogInactiveIcon}
            petSpeciesRef={dogSpeciesRef}
          />

          <SpecieSelectorItem
            describedbyId={describedbyId}
            handleSpecieSelected={handleCatSelected}
            isSelected={catSelected.selected}
            label={t('petForm.cat')}
            petIcon={catIcon}
            petInactiveIcon={catInactiveIcon}
          />
        </div>

        <FigoInputMessage
          id={describedbyId}
          message={error}
          noBlankSpace={noBlankSpace}
        />
      </div>
    </div>
  );
};

export { AddPetSpecieSelector };
